import { render, staticRenderFns } from "./ReservationsPage.vue?vue&type=template&id=2f63c751&scoped=true"
import script from "./ReservationsPage.vue?vue&type=script&lang=js"
export * from "./ReservationsPage.vue?vue&type=script&lang=js"
import style0 from "./ReservationsPage.vue?vue&type=style&index=0&id=2f63c751&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f63c751",
  null
  
)

export default component.exports